import { Skeleton } from "~/components/ui/skeleton";

type PageSkeletonProps = {
  className?: string;
};

export const PageSkeleton = ({ className = "" }: PageSkeletonProps) => {
  return (
    <div className="flex justify-center w-full">
      <Skeleton className={`w-[98%] ${className}`} />
    </div>
  );
};
